import * as React from 'react';
import { navigate } from 'router';

import CurrentOrgInjector from '~/apps/shared/containers/app/CurrentOrgInjector';
import OrgLocationList from '~/apps/shared/containers/locations/OrgLocationList';


export default function() {
  return (
    <CurrentOrgInjector
      component={OrgLocationList}
      onEdit={(locationId: string) => {
        return navigate('sender.locations.edit', {locationId});
      }}
    />
  );
};
